import WarningIcon from "@mui/icons-material/Warning";
import { Chip } from "@mui/material";
import React from "react";

interface DelayAlertProps {
	show: boolean;
}

export const DelayAlert: React.FC<DelayAlertProps> = ({ show }) => {
	if (!show) {
		return null;
	}

	return (
		<Chip
			icon={<WarningIcon />}
			label="DELAY"
			sx={{
				backgroundColor: "#ff4d4f",
				color: "white",
				fontWeight: "bold",
				fontSize: "0.75rem",
				height: "28px",
				border: "2px solid #ff4d4f",
				borderRadius: "8px",
				"& .MuiChip-icon": {
					color: "white",
					fontSize: "1rem",
				},
			}}
			size="small"
		/>
	);
};
